import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './global.css'

// En desarrollo, deshabilitar StrictMode para evitar doble montaje de WebGL contexts
// StrictMode monta/desmonta componentes 2 veces en desarrollo, lo cual crea múltiples contextos WebGL
const AppWrapper = (
  <StrictMode>
    <App />
  </StrictMode>
)

createRoot(document.getElementById('root')).render(AppWrapper)
